<template>
    <sub-menu id="digital-signage">
        <sub-menu-item to="/restauration/food-force-for-restaurants|/restauration/food-force-pour-restaurants" icon="fa-user-chef">
            <span v-tr>FoodForce for Restaurants|FoodForce pour les restaurants</span>
        </sub-menu-item>
        <sub-menu-item to="/restauration/easy-self-ordering|/restauration/commande-autonome" icon="fa-bags-shopping">
            <span v-tr>Self-Ordering Application|Commande autonome</span>
        </sub-menu-item>
        <sub-menu-item to="/restauration/mev-srm-compatible|/restauration/compatibilite-mev" icon="fa-shield-check">
            <span v-tr>Québec SRM Compatible|Compatible MEV Québec</span>
        </sub-menu-item>
        <sub-menu-item to="/restauration/digital-signage-for-restaurants|/restauration/affichage-numerique-pour-restaurants" icon="fa-tv">
            <span v-tr>Digital Signage for Restaurants|Affichage pour restaurants</span>
        </sub-menu-item>
        <sub-menu-item to="/restauration/menuboard-designer|/restauration/conception-et-design-menus" icon="fa-paint-brush-alt">
            <span v-tr>Menuboards Designer|Création de menus</span>
        </sub-menu-item>
        <sub-menu-item to="/restauration/qr-code-and-demos|/restauration/codes-qr-et-demos" icon="fa-clapperboard-play">
            <span v-tr>Videos & Demonstrations|Vidéos et démonstrations</span>
        </sub-menu-item>
        <sub-menu-item to="/restauration/clients|/restauration/nos-clients" icon="fa-users-crown">
            <span v-tr>Our Clients|Nos clients</span>
        </sub-menu-item>
    </sub-menu>
</template>

<script>

import SubMenuItem from "@/components/sub-menu-item.vue";
import SubMenu from "@/components/sub-menu.vue";
export default {
    name: `restauration-navigation`,
    components: {SubMenuItem, SubMenu}
}
</script>

<style lang="scss" scoped>
</style>
